import { BaseCompany as CompanyResponse } from '@/DTOS/Company/Response/BaseCompany';
import { DownloadOutlined, EditOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Tag, Tooltip, Upload } from 'antd';
import React from 'react';

export const CompanyColumn = (
  handleEdit: (record: any) => void,
  printToPdf: (record: any) => void,
  downloadGDPR: (record: any) => void,
  getUploadProps: (record: any) => object | undefined,
  tires: any[]
) => [
  {
    title: 'Client Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Tip de client',
    dataIndex: 'type',
    key: 'type',
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Denunmire',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Manager de cont',
    dataIndex: 'accountManager',
    key: 'accountManager',
    render: (record: { name: any }) => (record ? record?.name : '-'),
  },
  {
    title: 'Grup',
    dataIndex: 'companyGroup',
    key: 'companyGroup',
    width: 150,
    render: (record: any) => (
      <Tooltip title={record}>
        <div className='ellipsis-cell'>{record ? record?.name : '-'}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Ranc',
    dataIndex: '',
    key: '',
    width: 150,
    render: (record: any) => {
      const rankName = tires?.find((t) => t.id == record?.enumCompanyRankId)?.name || '-';
      return (
        <Tooltip title={rankName}>
          <div className='ellipsis-cell'>{rankName}</div>
        </Tooltip>
      );
    },
  },
  {
    title: 'Administrator',
    dataIndex: 'leadership',
    key: 'leadership',
    width: 200,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Adresa',
    dataIndex: 'address',
    key: 'address',
    width: 200,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },
  {
    title: 'CNP',
    dataIndex: 'cnp',
    key: 'cnp',
    width: 200,
    render: (record: any) => (
      <Tooltip title={record}>
        <div className='ellipsis-cell'>{record ? record : '-'}</div>
      </Tooltip>
    ),
  },
  {
    title: 'CUI',
    dataIndex: 'cui',
    key: 'cui',
    width: 200,
    render: (record: any) => (
      <Tooltip title={record}>
        <div className='ellipsis-cell'>{record ? record : '-'}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Banca',
    dataIndex: 'bank',
    key: 'bank',
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },
  {
    title: 'IBAN',
    dataIndex: 'bankAccount',
    key: 'bankAccount',
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Numar inregistrare',
    dataIndex: 'registrationNumber',
    key: 'registrationNumber',
    width: 200,
    render: (record: any) => (
      <Tooltip title={record}>
        <div className='ellipsis-cell'>{record ? record : '-'}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Descrierea activitatii',
    dataIndex: 'activityDescription',
    key: 'activityDescription',
    width: 200,
    render: (record: any) => (
      <Tooltip title={record}>
        <div className='ellipsis-cell'>{record ? record : '-'}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Telefon',
    dataIndex: 'phone',
    key: 'phone',
    render: (_: any, record: { phone: any[] }) => (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
      >
        {record?.phone?.map((item, index) => (
          <Tag color={'blue'} key={`phone_${index}`}>
            {item}
          </Tag>
        ))}
        {!record?.phone && <Tag color={'blue'}>-</Tag>}
      </div>
    ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: (_: any, record: any) => (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
      >
        {record?.email?.map((item: any, index: any) => (
          <Tag color={'blue'} key={`email_${index}`}>
            {item}
          </Tag>
        ))}
        {!record?.email && <Tag color={'blue'}>-</Tag>}
      </div>
    ),
  },
  {
    title: 'Adresa web',
    dataIndex: 'webAddress',
    key: 'webAddress',
    width: 200,
    render: (record: any) => (
      <Tooltip title={record}>
        <div className='ellipsis-cell'>{record ? record : '-'}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Actiune',
    dataIndex: '',
    key: 'actions',
    render: (record: any) => (
      <>
        <Tooltip title='Modifica'>
          <Button onClick={() => handleEdit(record)} icon={<EditOutlined />}></Button>
        </Tooltip>{' '}
        <Upload {...(getUploadProps(record.id) || {})}>
          <Tooltip title='Incarca Pdf GDPR'>
            <Button icon={<UploadOutlined />}></Button>
          </Tooltip>
        </Upload>
      </>
    ),
    fixed: 'right',
  },
  {
    title: ' ',
    dataIndex: '',
    key: 'actions',
    fixed: 'right',
    render: (record: CompanyResponse) =>
      !record?.haveFile ? (
        <Tooltip title='Descărcare PDF'>
          <Button type='primary' icon={<DownloadOutlined />} onClick={() => printToPdf(record)}></Button>
        </Tooltip>
      ) : (
        <Button type='primary' onClick={() => downloadGDPR(record)}>
          <DownloadOutlined />
          GDPR Semnat
        </Button>
      ),
  },
];
